const map = {
	"./ar/shop.json": [
		92842,
		[
			2842
		]
	],
	"./de/shop.json": [
		65374,
		[
			5374
		]
	],
	"./en/shop.json": [
		27738,
		[
			7738
		]
	],
	"./es/shop.json": [
		91019,
		[
			1019
		]
	],
	"./fa/shop.json": [
		91868,
		[]
	],
	"./fr/shop.json": [
		10499,
		[
			499
		]
	],
	"./ja/shop.json": [
		93016,
		[
			3016
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 91492;
module.exports = webpackAsyncContext;